var _style, _defs, _path, _path2, _ellipse, _ellipse2, _path3, _line, _defs2, _path4, _line2, _line3, _line4, _defs3, _line5, _line6, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:none;stroke:#88898A;stroke-width:17.1;stroke-linecap:round;}\n\t.st1{clip-path:url(#SVGID_2_);fill:none;stroke:#88898A;stroke-width:17.1;}\n\t.st2{clip-path:url(#SVGID_2_);fill:none;stroke:#88898A;stroke-width:17.1;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:none;stroke:#88898A;stroke-width:17.1;stroke-linecap:round;}\n\t.st4{clip-path:url(#SVGID_4_);fill:none;stroke:#88898A;stroke-width:17.1;stroke-linecap:round;}\n\t.st5{clip-path:url(#SVGID_6_);fill:none;stroke:#88898A;stroke-width:17.1;stroke-linecap:round;}\n\t.st6{clip-path:url(#SVGID_6_);fill:none;stroke:#88898A;stroke-width:17.1;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:none;stroke:#F7B01E;stroke-width:17.1;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 217.5,
    y: 207.4,
    width: 564.9,
    height: 585.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.2,576.1l0,181.4c0,7.2,2.7,26.5,27.2,26.5h90.2c24.4,0,27.2-19.3,27.2-26.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.4,675.9l0,81.6c0,7.2,2.7,26.5,27.2,26.5h51.3c24.4,0,27.2-19.3,27.2-26.5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -99.6875 335.8922)",
    className: "st1",
    cx: 355.6,
    cy: 288.3,
    rx: 72.3,
    ry: 72.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.1083 540.0845)",
    className: "st1",
    cx: 644.4,
    cy: 288.3,
    rx: 72.3,
    ry: 72.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M485.1,545.6l-23.7-154.1c0-5.2-4.2-9.5-9.5-9.5h-36.2c-16.3,13.7-37.1,22.3-60.1,22.3 c-23,0-43.8-8.6-60.1-22.3h-36.2c-5.2,0-9.5,4.2-9.5,9.5l-23.7,154.1c0,5.2,49.3,32.4,129.2,33.2 C435.1,579.6,485.1,550.9,485.1,545.6z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 287.2,
    y1: 438.7,
    x2: 271,
    y2: 563.5
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 217.5,
    y: 207.4,
    width: 564.9,
    height: 585.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M575.9,438.7L546.7,651c0,4,37.2,24.5,97.4,25c60.2,0.6,97.9-21.1,97.9-25l-29.2-212.3"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 424.1,
    y1: 438.7,
    x2: 440.2,
    y2: 563.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 428.7,
    y1: 576.1,
    x2: 428.7,
    y2: 757.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 698,
    y1: 679,
    x2: 698,
    y2: 757.5
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 217.5,
    y: 207.4,
    width: 564.9,
    height: 585.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 355.6,
    y1: 629.2,
    x2: 355.6,
    y2: 776.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 644.4,
    y1: 688.3,
    x2: 644.4,
    y2: 776.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M730.7,567.2c27.6-8.3,43.2-18.6,43.2-21.5l-23.7-154.1c0-5.2-4.2-9.5-9.5-9.5h-36.2 c-16.3,13.7-37.1,22.3-60.1,22.3c-23,0-43.8-8.6-60.1-22.3h-36.2c-5.2,0-9.5,4.2-9.5,9.5l-23.7,154.1c0,2.9,15.5,12.8,43.1,21"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M728.8,567.1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.38afd4ecb91159a8ddb1a8b2cf5b752e.svg";
export { ForwardRef as ReactComponent };